let preventativeMaintenanceComponent = {
  restrict: "E",
  bindings: {},
};

export default preventativeMaintenanceComponent;



// WEBPACK FOOTER //
// ./client/app/components/preventative_maintenance/preventative_maintenance.component.js